<template>
  <Dialog
    title="消息详情"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose"
  >
    <el-descriptions :column="1" border v-if="dialogVisible">
      <el-descriptions-item label="标题">
        {{ message.title }}
      </el-descriptions-item>
      <el-descriptions-item label="内容">
        {{ message.content }}
      </el-descriptions-item>
      <el-descriptions-item label="接收对象">
        {{
          message.recipientType == 1
            ? "全部学员"
            : message.recipientMemberNames.join(",")
        }}
      </el-descriptions-item>
      <el-descriptions-item label="发送时间">
        {{ message.sendTime }}
      </el-descriptions-item>
      <el-descriptions-item label="状态">
        {{ message.sendStatus == 0 ? "未发送" : "已发送" }}
      </el-descriptions-item>
    </el-descriptions>
  </Dialog>
</template>
<script>
import { getMessageDetail } from "@/api/message";
export default {
  data() {
    return {
      dialogVisible: false,
      message: {}
    };
  },
  methods: {
    async open(id) {
      const res = await getMessageDetail(id);
      this.message = res.data;
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Message/MessageDetail.vue